import React, { ReactElement, FC } from 'react';

import styles from './styles.module.scss';

import { VotingCoalitionsTable } from './components';
import { BlurredProBanner } from '../BlurredProBanner';
import { blurredCoalitionsContent } from './constants';
import { OrganizationCoalitionsProps } from './types';

export const OrganizationCoalitions: FC<OrganizationCoalitionsProps> = ({
    isPremiumAllowed,
    isInTop100,
}): ReactElement => {
    if (isInTop100) {
        if (!isPremiumAllowed) {
            return (
                <div className={styles.container}>
                    <BlurredProBanner
                        title="Delegate / voter Power Groups is a DeepDAO Pro feature"
                        description={'Groups of delegates, or voters and their combined voting power. A deep insight into whether the DAO is decentralized or not'}
                    >
                        {blurredCoalitionsContent}
                    </BlurredProBanner>
                </div>
            );
        }
    }

    return (
        <div className={styles.container}>
            <VotingCoalitionsTable />
        </div>
    );
};
